import { lazy } from 'react';
// project import
import Loadable from 'components/Loadable';

// ==============================|| ROUTES ITEMS - PROFILE ||============================== //

const UserProfile = Loadable(lazy(() => import('pages/nostradamus/profile/UserProfilePage')));

const profile = {
    path: 'profile',
    element: <UserProfile />
};

export default profile;
